// extracted by mini-css-extract-plugin
export default {"instanceDetails":"instanceDetails-module__instanceDetails___mNGhy","instanceDetails__content":"instanceDetails-module__instanceDetails__content___lsHGF"};